export function normalizeThoughtDetailsArray(val) {
  if (!Array.isArray(val)) return null
  const out = []
  for (const item of val) {
    if (typeof item === 'string') {
      const t = item.trim()
      if (t) out.push(t)
    } else if (item && typeof item === 'object' && typeof item.text === 'string') {
      const t = String(item.text).trim()
      if (t) out.push(t)
    } else if (item && typeof item === 'object') {
      const label = typeof item.label === 'string' ? item.label.trim() : ''
      const summary = typeof item.summary === 'string' ? item.summary.trim() : ''
      const seconds = Number.isFinite(item.seconds) ? ` (${Number(item.seconds).toFixed(1)}s)` : ''
      const t = [label, summary].filter(Boolean).join(': ')
      if (t) out.push(`${t}${seconds}`)
    }
  }
  return out.length ? out : null
}

export function firstString(...vals) {
  for (const v of vals) {
    if (typeof v === 'string') {
      const t = v.trim()
      if (t) return t
    }
  }
  return null
}
